import { useContext } from 'react';
import { Box } from '@mui/material';

import LanguageContext from "../../../contexts/LanguageContext"

import noCompletionChartIcon from "../../../images/noCompletionChartIcon.svg"

/* E2, review du 02/09 : etat « donnees non disponibles » commun a Progression
   et Certification, calque sur celui des blocs de l'Accueil. Avant, ces deux
   ecrans restaient sur un chargement infini (Progression) ou une page vide
   (Certification) quand aucun groupe de l'ecole n'avait de donnees. */
const NoDataScreen = ({ reseau }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <Box sx={{flex:1, height:"calc(100vh - 300px)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"15px"}}>
      <Box sx={{
        width:["50px", "60px", "60px", "75px"],
        minWidth:["50px", "60px", "60px", "75px"],
      }}>
        <img src={noCompletionChartIcon} style={{width:"100%"}} alt=""/>
      </Box>
      <Box sx={{
        color:"text.black",
        fontSize:["20px", "24px", "24px", "26px"],
        textAlign:"center",
      }}>
        {reseau === true
          ? languageValues?.adminDashboard?.noDataScreen?.titreReseau?.[actLanguage]
          : languageValues?.adminDashboard?.noDataScreen?.title[actLanguage]}
      </Box>
      <Box sx={{
        color:"text.subTitle",
        fontSize:["15px", "16px", "16px", "17px"],
        textAlign:"center",
        maxWidth:"340px",
      }}>
        {reseau === true
          ? languageValues?.adminDashboard?.noDataScreen?.sousTitreReseau?.[actLanguage]
          : languageValues?.adminDashboard?.noDataScreen?.subTitle[actLanguage]}
      </Box>
    </Box>
  )
}

export default NoDataScreen
